/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';
import styles from './MainPage.module.css';
import Navbar from '../navbar/Navbar';
import { setNavigator } from '../../../axiosMiddleware/navigation';
import getProfile from '../../../apiServices/profile/profile';
import { useProfile } from '../../../Providers/ProfileProvider';
import Loading from '../../loadingAnimation/Loading';

function MainPage({
  children,
  viewList,
  loading,
}) {
  const { setProfile } = useProfile();
  const [open, setOpen] = useState(() => window.innerWidth > 900);
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  const handleGetProfile = async () => {
    if (!loading) {
      const response = await getProfile();
      if (response.data) {
        setProfile(response.data);
        localStorage.setItem('currentWorkspace', response.data.config.currentWorkspace);
      }
    }
  };

  useEffect(() => {
    handleGetProfile();
  }, [navigate]);
  return (
    <div
      id="mainContainer"
      className={styles.mainContainer}
      aria-label="Main page"
    >
      {!loading && <Sidebar viewList={viewList} open={open} onClose={() => setOpen(false)} />}
      <motion.div
        layout
        transition={{ duration: 0.1, ease: 'easeInOut' }}
        className={styles.mainInner}
        style={{
          boxSizing: 'border-box',
          background: 'var(--color-surface-elevated)',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Navbar open={open} setOpen={setOpen} />
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            boxSizing: 'border-box',
            display: 'flex',
            direction: 'column',
            width: '100%',
          }}
          className={styles.scrollableContent}
        >
          {children}
        </div>
        { loading && (
        <div style={{
          position: 'absolute',
          inset: 0,
          height: '100%',
          width: '100%',
          background: 'var(--color-surface-elevated)',
          zIndex: 1000,
        }}
        >
          <Loading />
        </div>
        )}
      </motion.div>
    </div>
  );
}

export default MainPage;
